import { BuilderViewConfig } from "./BuilderViewConfig"
import { RestConfig } from "./RestConfig"


export const AppConfig = {

    //Builder整体配置
    BUILDER_VIEW: BuilderViewConfig,

    //Rest配置
    REST: RestConfig,
}

export const RuntimeContext = {
    //rest请求相关
    rest: {
        //rest请求的基础domain，用于处理跨域请求问题
        rootPath: AppConfig.REST.DEFAULT_ROOT_PATH,
        //业务网站传入的partnerToken对象
        partnerToken: {
            token_type: null,
            access_token: null
        },
        partnerId: null
    },
    //Builder初始化配置
    builder: {
        propertyModelId: null,
        productId: null,
        storeProductId:null,
        productInstanceId: null,
        orderItemId: null,
        language: AppConfig.BUILDER_VIEW.DEFAULT_LANGUAGE,
        region: AppConfig.BUILDER_VIEW.DEFAULT_REGION,
        themes: AppConfig.BUILDER_VIEW.DEFAULT_THEMES,
        //使用测试版本配置
        useTestVersion: false,
        // builder加载时,是否回到历史步骤
        useHistory: false,
        // 更新策略
        updateTactics: "forget", //forget beforeNavigation edited
        configurableProductId: "",
        //用户是否输入了主题
        userThemes: false,
        //外部传入的logo 完整的URL地址
        logo: "",
        //默认不是移动端
        isMobile:false,
        equipmentType:"",
        //图片根路径
        imgRootPath:""
    }

}